/* CLIPBOARD PDP — rotador de palabras del hero.
   Una palabra visible por vez: la que sale se va hacia arriba, la que entra
   sube desde abajo. Sin timeline CSS gigante (era lo que se rompía cuando
   cambiaba la cantidad de palabras o el tamaño de fuente).
   Buildless: se carga con <script defer> desde el snippet. */
(function () {
  var HOLD = 1200; // ms que queda quieta cada palabra (~20% más rápido)
  var FIRST = 520; // primer cambio más corto, para que no sienta countdown al entrar
  var ANIM = 680; // ms de la transición (igual que el CSS)

  function initRotator(root) {
    if (root.dataset.clipboardRotatorReady === '1') return;
    root.dataset.clipboardRotatorReady = '1';

    var words = Array.prototype.slice.call(root.querySelectorAll('.clipboard-rotator__word'));
    if (words.length < 2) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var started = false;

    // Ojo: nada de asignar className entero. Cada palabra lleva su clase de
    // color (--red, --green, ...) y pisarla dejaba el texto transparente sin
    // gradiente, o sea invisible. Solo tocamos las clases de estado.
    var ESTADOS = ['is-active', 'is-below', 'is-exiting', 'from-below'];

    function setEstado(word) {
      var nuevos = Array.prototype.slice.call(arguments, 1);
      ESTADOS.forEach(function (c) {
        if (nuevos.indexOf(c) === -1) word.classList.remove(c);
      });
      nuevos.forEach(function (c) { word.classList.add(c); });
    }

    words.forEach(function (word, i) {
      setEstado(word, i === 0 ? 'is-active' : 'is-below');
    });

    if (reduce) return;

    function step() {
      var current = words[index];
      var next = words[(index + 1) % words.length];

      setEstado(current, 'is-exiting');
      setEstado(next, 'is-active', 'from-below');

      window.setTimeout(function () {
        setEstado(current, 'is-below');
      }, ANIM);

      index = (index + 1) % words.length;
      timer = window.setTimeout(step, HOLD + ANIM);
    }

    function start() {
      if (timer) return;
      timer = window.setTimeout(function () {
        started = true;
        step();
      }, started ? HOLD : FIRST);
    }

    function stop() {
      window.clearTimeout(timer);
      timer = null;
    }

    // No gastar frames con la pestaña en segundo plano ni con el hero fuera de vista.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    if (!document.hidden) start();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !document.hidden) start();
          else stop();
        });
      }, { threshold: 0 }).observe(root);
    }
  }

  // Los 3 videos de abajo del fold no se bajan hasta que entran en pantalla,
  // y se pausan al salir: 4 videos de 1720x1080 corriendo a la vez no se pagan.
  function initLazyVideos() {
    var vids = document.querySelectorAll('[data-clipboard-lazy-video]');
    if (!vids.length) return;

    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) {
        if (!v.src) v.src = v.dataset.src;
        v.play().catch(function () {});
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.src) v.src = v.dataset.src;
          v.play().catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.15 });

    vids.forEach(function (v) { io.observe(v); });
  }

  function init() {
    document.querySelectorAll('[data-clipboard-rotator]').forEach(initRotator);
    initLazyVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de temas vuelve a inyectar la sección al editarla.
  document.addEventListener('shopify:section:load', init);
})();
